export default {
    current_choice: 'Τρέχουσα επιλογή',
    book_now: 'Κάντε κράτηση τώρα',
    minimum_age: 'Μόνο για άτομα άνω των {age}',
    excess_liability: 'Υπευθυνότητα υπερβάλλοντος',
    security_deposit: 'Εγγύηση ασφαλείας',
    fuel_policy: 'Πολιτική καυσίμων',
    like_for_like: 'Ίδιο για ίδιο',
    full_to_full: 'Γεμάτο προς γεμάτο',
    miles_per_rental: '{mileage} δωρεάν μίλια ανά ενοικίαση',
    km_per_rental: '{mileage} δωρεάν χλμ ανά ενοικίαση',
    unlimited_mileage: 'Απεριόριστα μίλια',
    unlimited_mileage_km: 'Απεριόριστα χλμ',
    non_amendable: 'Μη τροποποιήσιμο',
    non_refundable: 'Μη επιστρέψιμο',
    free_cancellation_until: 'Δωρεάν ακύρωση έως',
    basic_free_cancellation: 'Δωρεάν ακύρωση έως 48 ώρες πριν από την ώρα έναρξης',
    cancellation_in_line_with: 'Ακύρωση σύμφωνα με',
    tcs: 'Όροι &amp; Προϋποθέσεις',
    free_extras_on_collection: 'Δύο δωρεάν επιπλέον κατά την παραλαβή',
    glass_and_tyres_covered: 'Κάλυψη γυαλιών και ελαστικών',
    number_of_passengers: 'Αριθμός επιβατών',
    number_of_bags: 'Αριθμός αποσκευών',
    fuel_type: 'Τύπος καυσίμου',
    co2: 'CO2',
    aircon: 'Κλιματισμός',
    transmission: 'Κιβώτιο ταχυτήτων',
    book_type: 'Κράτηση {type}',
    debit_card_deposit: 'Δεκτή κάρτα χρέωσης για εγγύηση',
    fast_track_included: 'Περιλαμβάνεται Fast Track',
    view_all: 'Δείτε όλα',
};
